import { cliente } from '@/lib/cliente';
import type { GuardarComentarioInput } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

function extraer<T>(res: { data: T | null; error: { mensaje: string } | null }): T {
  if (!res.data) throw new Error(res.error?.mensaje ?? 'Error del servidor');
  return res.data;
}

export function useComentarios(anio: number, mes: number) {
  return useQuery({
    queryKey: ['comentarios', anio, mes],
    queryFn: () => cliente.comentarios.listar({ anio, mes }).then((r) => extraer(r).comentarios),
  });
}

export function useGuardarComentario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: GuardarComentarioInput) => cliente.comentarios.guardar(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['comentarios', vars.anio, vars.mes] });
    },
  });
}

export function useEliminarComentario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: number; anio: number; mes: number }) =>
      cliente.comentarios.eliminar(id),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['comentarios', vars.anio, vars.mes] });
    },
  });
}
